// apps/web/src/routes/(showcase)/layout.tsx
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { BackToOverview } from "~/components/showcase/back-to-overview";
import { PaperTexture } from "~/components/showcase/ornaments/paper-texture";
import { ShowcaseTopBar } from "~/components/showcase/top-bar";
import { TourOverlay } from "~/components/showcase/tour/tour-overlay";
import { SkinProvider } from "~/lib/showcase/skin";
import { $readSkinCookie } from "~/lib/showcase/skin.queries";
import { TourProvider } from "~/lib/showcase/tour-context";
import * as m from "~/paraglide/messages.js";

export const Route = createFileRoute("/(showcase)")({
  // Showcase routes are not CDN-cached, so reading the per-visitor skin cookie
  // here is safe. The root shell no longer provides it (that would bleed across
  // cached public responses); this keeps `Route.useRouteContext().skin` working.
  beforeLoad: async () => ({ skin: await $readSkinCookie() }),
  component: ShowcaseLayout,
});

function ShowcaseLayout() {
  const { skin } = Route.useRouteContext();
  return (
    <SkinProvider initial={skin}>
      <TourProvider>
        <div
          className="flex min-h-screen flex-col bg-[var(--sc-bg)] font-[var(--sc-font-body)] text-[var(--sc-fg)]"
          data-skin={skin}
        >
          <a className="sc-skip-link" href="#sc-main">
            {m.showcase_skip_to_main()}
          </a>
          <PaperTexture />
          <ShowcaseTopBar />
          <main className="flex-1" id="sc-main">
            <BackToOverview />
            <Outlet />
          </main>
          <TourOverlay />
        </div>
      </TourProvider>
    </SkinProvider>
  );
}
